import React, { useState } from "react";
import PropTypes from "prop-types";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const WithdrawalRequestsTab = ({ requests = [], loading = false, onApprove, onReject, startIndex = 0 }) => {
  const [processingId, setProcessingId] = useState(null);

  const handleApproveClick = async (request) => {
    setProcessingId(request.id);
    if (onApprove) {
      await onApprove(request.id);
    }
    setProcessingId(null);
  };

  const handleRejectClick = async (request) => {
    setProcessingId(request.id);
    if (onReject) {
      await onReject(request.id);
    }
    setProcessingId(null);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <Spin indicator={antIcon} />
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="overflow-x-auto border rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="px-4 py-2 text-left">#</th>
              <th className="px-4 py-2 text-left">Date</th>
              <th className="px-4 py-2 text-left">Amount (Rs.)</th>
              <th className="px-4 py-2 text-left">Method</th>
              <th className="px-4 py-2 text-left">Reference</th>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-4 py-2 text-left">Note</th>
              <th className="px-4 py-2 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request, index) => (
              <tr key={request.id} className="border-b hover:bg-gray-50">
                <td className="px-4 py-2 font-medium">{startIndex + index + 1}</td>
                <td className="px-4 py-2">
                  {request.created_at
                    ? new Date(request.created_at).toLocaleDateString()
                    : request.date
                    ? new Date(request.date).toLocaleDateString()
                    : "-"}
                </td>
                <td className="px-4 py-2 font-semibold text-blue-600">
                  Rs. {Number(request.amount || 0).toLocaleString("en-IN")}
                </td>
                <td className="px-4 py-2">{request.method || request.payment_method || "-"}</td>
                <td className="px-4 py-2 font-medium text-gray-600">
                  {request.reference || request.transaction_id || "-"}
                </td>
                <td className="px-4 py-2">
                  <span
                    className={`text-xs font-semibold px-2.5 py-1 rounded-full ${
                      request.status === "approved" || request.status === "completed"
                        ? "bg-green-100 text-green-700"
                        : request.status === "rejected" || request.status === "failed"
                        ? "bg-red-100 text-red-700"
                        : request.status === "pending"
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-gray-100 text-gray-700"
                    }`}
                  >
                    {request.status || "pending"}
                  </span>
                </td>
                <td className="px-4 py-2 text-gray-600 text-xs max-w-xs truncate">
                  {request.note || request.description || "-"}
                </td>
                <td className="px-4 py-2">
                  {request.status === "pending" ? (
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={() => handleApproveClick(request)}
                        disabled={processingId === request.id}
                        className="px-2 py-1 text-xs rounded bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
                      >
                        {processingId === request.id ? "Processing..." : "Approve"}
                      </button>
                      <button
                        type="button"
                        onClick={() => handleRejectClick(request)}
                        disabled={processingId === request.id}
                        className="px-2 py-1 text-xs rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
                      >
                        {processingId === request.id ? "Processing..." : "Reject"}
                      </button>
                    </div>
                  ) : (
                    <span className="text-xs text-gray-500 font-medium">
                      {request.status === "approved" ? "✓ Approved" : "✗ Rejected"}
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {requests.length === 0 && (
          <div className="p-8 text-center text-gray-500">
            <p className="text-sm">No withdrawal requests found for this partner.</p>
          </div>
        )}
      </div>
    </div>
  );
};

WithdrawalRequestsTab.propTypes = {
  requests: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  onApprove: PropTypes.func,
  onReject: PropTypes.func,
  startIndex: PropTypes.number,
};

export default WithdrawalRequestsTab;
